import { padEnd } from 'lodash';
export const maxFractionDigits = 6;

export const getNumberInputFieldMaxFractionDigitsStep = () =>
  '0.' + padEnd('', maxFractionDigits - 1, '0') + '1';
